import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { FormikValues } from "formik";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

import { getValidationRule } from "../../validationRules";
import { Rules } from "../../validationRules/types";

export function getReferenceDate(
  reference: components["schemas"]["EmploymentReferencesValue"]
) {
  return `${formatDate(reference.start_date, "MMM yyyy")} - ${
    reference.end_date
      ? formatDate(reference.end_date, "MMM yyyy")
      : t("Present")
  }`;
}

export function useSkipReason() {
  const { t } = useTranslation();

  const skipReasons = {
    NO_EMPLOYER_REFERENCES: t("I don't have any employer references"),
    NO_RECENT_EMPLOYER_REFERENCES: t(
      "I don't have any recent employer references"
    ),
    NOT_ENOUGH_EMPLOYER_REFERENCES: t(
      "I don't have enough employer references"
    ),
    DO_NOT_CONTACT_EMPLOYER_REFERENCES: t(
      "I don't want my employer reference(s) to be contacted"
    ),
  };

  return {
    getTranslatedReason: (key: string) =>
      skipReasons[key as keyof typeof skipReasons] ?? key,
    skipReasons,
  };
}

export function getReferencesRuleResults({
  field,
  values,
}: {
  field: components["schemas"]["EmploymentReferencesCheckField"];
  values?: FormikValues;
}) {
  const requireAmount = getValidationRule(
    field,
    Rules.REQUIRE_EMPLOYMENT_REFERENCES
  );
  const requireYears = getValidationRule(
    field,
    Rules.REQUIRE_EMPLOYMENT_REFERENCE_WITHIN_YEARS
  );

  const requiredCount = (
    (requireYears?.rule as components["schemas"]["RequireEmploymentReferencesWithinXYearsRule"]) ??
    (requireAmount?.rule as components["schemas"]["RequireEmploymentReferencesRule"])
  )?.value;

  const isValid = (requireYears ?? requireAmount)?.isValid(values);

  return {
    requiredCount,
    requireAmount,
    requireYears,
    isValid,
  };
}
